import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-plan',
  templateUrl: './pricing-plan.component.html',
  styleUrls: ['./pricing-plan.component.scss']
})
export class PricingPlanComponent implements OnInit {

  logoImg:string=`../../../assets/imgs/logo/se2in_logo.png`;

  data : any = {
    title: "Pricing"
  };
  constructor() { }

  ngOnInit(): void { }
}
